import {useContractStatus} from 'presentation/hooks';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {useBookingConfirmationDrawer} from 'presentation/pages/private/booking/hooks/useBookingConfirmationDrawer';
import {
	useAccountInformation,
	useMediaQueries,
	useQueryParams,
} from 'presentation/pages/private/hooks';
import {useCongenereEligibilityStore} from 'presentation/pages/private/store/useCongenereEligibilityStore';
import {translations} from 'presentation/translations-new';

const {emptyState} = translations['pt-br'].privateFlow.examResults;

export const useExamsListEmptyState = (isWaitingResult: boolean) => {
	const {isMobile} = useMediaQueries();
	const {SEARCH_PARAMS} = useQueryParams();
	const {isValid, isContractSuspended} = useContractStatus();
	const {odontoOnly, flPlanoSomenteHospitalar} = useAccountInformation();
	const congenereEligibility = useCongenereEligibilityStore(state => state.congenereEligibility);
	const {category, month, examType} = SEARCH_PARAMS;
	const hasFilterActive = !!category || !!month || !!examType;
	const showBookingButton =
		isValid &&
		!isContractSuspended &&
		!(odontoOnly || flPlanoSomenteHospitalar) &&
		!hasFilterActive &&
		!congenereEligibility;

	const emptyDescription = () => {
		if (hasFilterActive) {
			return emptyState.descriptionFilterActive;
		}

		return isWaitingResult ? emptyState.description : emptyState.descriptionSelectedDate;
	};

	const {handleOpenBookingConfirmationDrawer, setSelectedServiceType} =
		useBookingConfirmationDrawer();

	const handleGoToBookingExam = () => {
		setSelectedServiceType(BookingTypeEnum.EXAM);
		handleOpenBookingConfirmationDrawer();
	};

	return {
		isMobile,
		hasFilterActive,
		showBookingButton,
		emptyDescription,
		handleGoToBookingExam,
	};
};
